import { render } from "./ListDistributionCenters.vue?vue&type=template&id=1320b61e"
import script from "./ListDistributionCenters.vue?vue&type=script&lang=js"
export * from "./ListDistributionCenters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__